import React, { Component } from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem } from 'react-bootstrap';
import Selection from '../Common/selection';
import InputField from '../Common/inputField';
import Spinner from '../Widgets/spinner';
import ReactDataGrid from 'react-data-grid';
import ContentWrapper from '../Layout/ContentWrapper';
import { Toolbar, Data } from 'react-data-grid-addons';

class WholesaleModal extends Component {
    constructor() {
      super();
      this.state = {
        rows: [],
        selectedRows: [],
        editedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      }
    }

    componentDidMount() {
      this.props.fetchInventoryBatches(this.props.ProductNum);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.inventoryBatches && nextProps.inventoryBatches != this.props.inventoryBatches) {
          this.setState({rows: nextProps.inventoryBatches});
      }
    }

    renderTable() {
      if (this.props.isLoading) return <Spinner/>
      else {
        // Parameters of the react-data-grid

        const getRows = () => {
            return Data.Selectors.getRows(this.state);
        }

        const getSize = () => {
            return getRows().length;
        }

        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }

        // Handle the sortable function

        const handleGridSort = (sortColumn, sortDirection) => {
            var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
            this.setState(state);
        }

        const handleFilterChange = filter => {
            let newFilters = Object.assign({}, this.state.filters);
            if (filter.filterTerm) {
                newFilters[filter.column.key] = filter;
            } else {
                delete newFilters[filter.column.key];
            }
            this.setState({ filters: newFilters });
        }

        // Handle the row select function

        const onRowSelect = rows => {
            this.setState({ selectedRows: rows });
        }

        const handleRowUpdated = e => {
            // merge updated row with current row and rerender by setting state
            let rows = this.state.rows.slice(0);
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            if(e.updated.Quantity != null) {
              Object.assign(rows[e.rowIdx], {Total: parseFloat(e.updated.Quantity*rows[e.rowIdx].UnitPrice).toFixed(2)});
            }
            if(e.updated.UnitPrice != null) {
              Object.assign(rows[e.rowIdx], {Total: parseFloat(e.updated.UnitPrice*rows[e.rowIdx].Quantity).toFixed(2)});
            }
            // if the element is already edited, remove the old one.
            editedRows.forEach((element, index) => {
                console.log(element.id, rows[e.rowIdx].id)
                if (element.id === rows[e.rowIdx].id)
                    editedRows.splice(index, 1)
            }, this);
            // push the row into the editedRows array
            editedRows.push(rows[e.rowIdx]);
            this.setState({
                rows: rows,
                editedRows: editedRows
            });
        }

        // const onRowClick = (rowIdx, row) => {
        //     this.props.fetchSalesOrders();
        // }

        //Custom Formatter component

        const DateFormatter = React.createClass({
            render() {
                if (this.props.value) {
                  let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                  let date = new Date(this.props.value)
                  let index = dateMap.indexOf(date.toString().slice(4,3));
                  let localDate = index + date.toString().slice(8, 6);
                  return <span>{date.toString().slice(4, 15)}</span>;;
                }
                else return <span className="label label-danger">-</span>;
            }
        });

        const VendorNameFormatter = React.createClass({
            render() {
                if (this.props.value) return <span>{this.props.value.Name}</span>;
                else return <span className="label label-danger">-</span>;
            }
        });

        const VendorNumFormatter = React.createClass({
            render() {
                if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                else return <span className="label label-danger">-</span>;
            }
        });

        // Column difinition

        const columns = [
            {
                key: 'Batch_PONum',
                name: 'Batch No.',
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true
            },
            {
                key: 'BatchAmount',
                name: 'In Stock',
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'Quantity',
                name: 'Quantity',
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
                editable: true
            },
            {
                key: 'ProductUnitOfMeasure',
                name: 'Unit',
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            },
            {
                key: 'UnitPrice',
                name: 'Unit Price',
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
                editable: true,
            },
            {
                key: 'Total',
                name: 'Total Price',
                resizable: true,
                sortable: true,
                width: 100,
                filterable: true,
            }
        ]

        return (
            <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="WholesaleModal-dataGrid1">
                <ReactDataGrid
                    style={{ height: 250 }}
                    rowKey='id'
                    enableCellSelect={true}
                    onGridSort={handleGridSort}
                    toolbar={<Toolbar enableFilter={true}/>}
                    onAddFilter={handleFilterChange}
                    columns={columns}
                    rowGetter={rowGetter}
                    rowsCount={getSize() }
                    onRowUpdated={handleRowUpdated}
                    onRowSelect={onRowSelect} />
            </div></Col></Row>
        )
      }
    }

    render() {
        const { closeC, moveToSO } = this.props;
        return (
            <ContentWrapper>
              <hr/>
              {this.renderTable()}
              <Row>
                  <button action="submit" onClick={(event) => { moveToSO(this.state.rows); closeC(); }} className="btn btn-primary col-sm-11 buttonStyle" >Move to S.O.</button>
              </Row>
              <br/>
              <Row>
                  <button className="btn btn-danger col-sm-11 buttonStyle" onClick={(event) => { event.preventDefault(); closeC(); } } >Cancel</button>
              </Row>
            </ContentWrapper>
        )
    }
}

export default WholesaleModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/wholesaleModal.jsx